<bizz-icon class="block" [ngClass]="iconSize" [ngStyle]="{ 'color': iconColor }" [iconLibrary]="iconLibrary"
           [iconName]="iconName"></bizz-icon>